import store from "../../store";
import { raiseNotification, NotificationType, dismissNotification } from "../../components/Navbar/notifications.redux";
import {client} from "../../clientInstance";
import * as notificationLocalState from "../../components/Navbar/NotificationPoller/notificationLocalState";

const notificationId = "Notification/ClientVersionOutdated";
const HTTPHeader = "Octopus-Node";
export const serverVersionNotificationCheck = (request: XMLHttpRequest) => {
    const clientVersion = client.version;
    const apiVersion = getApiVersion(request);

    if (!apiVersion) {
        return;
    }

    if (apiVersion === clientVersion) {
        notificationLocalState.clearValue(notificationId);
        dismissNotification(store.dispatch)(notificationId);
        return;
    }

    const description = `The current web portal is running as version ${clientVersion} however Octopus Server is
    running ${apiVersion}. Refresh this page to ensure you have the latest portal version.`;

    raiseNotification(store.dispatch)({
        id: notificationId,
        value: apiVersion,
        type: NotificationType.info,
        description,
        text: "Server version updated",
        links: [{type: "Refresh", label: "Reload Site"}]
    });
};

function getApiVersion(request: XMLHttpRequest): string {
    let nodeVersion = request.getResponseHeader(HTTPHeader);
    if (!nodeVersion) {
        return;
    }

    nodeVersion = nodeVersion.split("; ").find(v => v.startsWith("version="));
    if (!nodeVersion) {
        return;
    }
    return nodeVersion.substr(8);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/http/serverVersionNotificationCheck.tsx